import { EditOutlined } from "@ant-design/icons";
import * as Sentry from "@sentry/react";
import { Button, Modal, Tooltip } from "antd";
import SpinLoader from "components/Loader/SpinLoader";
import { useAlert } from "components/UI/alertSakeBar/alertProvider";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { handleUpdateDifferntiationlession } from "store/DifferentiationLesson/thunks";
import { handleUpdateSuperlession } from "store/SuperLesson/thunks";
import SunEditor from "suneditor-react";

import {
    align,
    blockquote,
    font,
    fontColor,
    fontSize,
    formatBlock,
    hiliteColor,
    horizontalRule,
    image,
    lineHeight,
    link,
    list,
    paragraphStyle,
    table,
    template,
    textStyle,
} from "suneditor/src/plugins";
import { SPANISH_ITEM_LOWER, SPANISH_ITEM_UPPER } from "utils/config/reference";
import { converMarkToHtml } from "utils/methods/textMethod";
const BUTTON_LIST = [
    [
        {
            name: "SPANISH_ITEM_LOWER",
            dataCommand: "SPANISH_ITEM_LOWER",
            buttonClass: "",
            title: `${SPANISH_ITEM_LOWER[0]}`,
            dataDisplay: "submenu",
            innerHTML: `<span>${SPANISH_ITEM_LOWER[0]}</span>`,
        },
    ],
    [
        {
            name: "SPANISH_ITEM_UPPER",
            dataCommand: "SPANISH_ITEM_UPPER",
            buttonClass: "",
            title: `${SPANISH_ITEM_UPPER[0]}`,
            dataDisplay: "submenu",
            innerHTML: `<span>${SPANISH_ITEM_UPPER[0]}</span>`,
        },
    ],
];
const SPANISH_ITEM_LOWER_PLUGIN = {
    name: "SPANISH_ITEM_LOWER",
    display: "submenu",
    add: function (core, targetElement) {
        let listDiv = this.setSubmenu.call(core);
        var self = this;
        listDiv.querySelectorAll(".se-btn-list-lower").forEach(function (btn) {
            btn.addEventListener("click", self.onClick.bind(core));
        });
        core.initMenuTarget(this.name, targetElement, listDiv);
    },

    setSubmenu: function () {
        const listDiv = this.util.createElement("DIV");
        listDiv.className = "se-submenu se-list-layer bubbleNotesEditor";
        listDiv.innerHTML = `<div class="se-list-inner se-list-font-size" style="width:30px;">
      <ul class="se-list-basic">
         ${SPANISH_ITEM_LOWER.map(
            (item) =>
                `<li><button type="button" class="se-btn-list-lower" value="${item}">${item}</button></li>`
        ).join("")}
      </ul></div>`;

        return listDiv;
    },
    onClick: function (e) {
        e.preventDefault();
        const value = e.target.value;
        const node = this.util.createElement("span");
        this.util.addClass(node, "se-custom-tag");
        node.textContent = value;
        this.insertNode(node);
        const zeroWidthSpace = this.util.createTextNode(this.util.zeroWidthSpace);
        node.parentNode.insertBefore(zeroWidthSpace, node.nextSibling);
        this.submenuOff();
    },
};
const SPANISH_ITEM_UPPER_PLUGIN = {
    name: "SPANISH_ITEM_UPPER",
    display: "submenu",
    add: function (core, targetElement) {
        let listDiv = this.setSubmenu.call(core);
        var self = this;
        listDiv.querySelectorAll(".se-btn-list-upper").forEach(function (btn) {
            btn.addEventListener("click", self.onClick.bind(core));
        });
        core.initMenuTarget(this.name, targetElement, listDiv);
    },

    setSubmenu: function () {
        const listDiv = this.util.createElement("DIV");
        listDiv.className = "se-submenu se-list-layer bubbleNotesEditor";
        listDiv.innerHTML = `<div class="se-list-inner se-list-font-size" style="width:30px;">
      <ul class="se-list-basic">
         ${SPANISH_ITEM_UPPER.map(
            (item) =>
                `<li><button type="button" class="se-btn-list-upper" value="${item}">${item}</button></li>`
        ).join("")}
      </ul></div>`;

        return listDiv;
    },
    onClick: function (e) {
        const value = e.target.value;
        const node = this.util.createElement("span");
        this.util.addClass(node, "se-custom-tag");
        node.textContent = value;
        this.insertNode(node);
        const zeroWidthSpace = this.util.createTextNode(this.util.zeroWidthSpace);
        node.parentNode.insertBefore(zeroWidthSpace, node.nextSibling);
        this.submenuOff();
    },
};



const extractInnerHtml = (html) => {
    const container = document.createElement("div");
    container.innerHTML = html;
    const lessonDiv = container.querySelector(".lesson-plan");
    return lessonDiv ? lessonDiv.innerHTML : html;
};

const SuperLessonEditor = ({ initialMarkdown, onSave, id  , isDifferentaition,from="",language="" }) => {
    const showAlert = useAlert();
    const [visible, setVisible] = useState(false);
    const [contentHtml, setContentHtml] = useState("");
    const editorRef = useRef();
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);

    const onUpdate = async (content) => {
        if(from === "sentence_starter"){
            setVisible(false);
            return;
        }
        try {
            if (id) {
                setLoader(true);
                let resp;
                if (isDifferentaition) {
                    resp = await dispatch(handleUpdateDifferntiationlession(id, content, language));
                } else {
                    resp = await dispatch(handleUpdateSuperlession(id, content,language));

                }
                if (resp && resp.success) {
                    showAlert(`Updated successfully`,"success")
                    setVisible(false);
                }else{
                    showAlert(`ERR-SU001 Error in updating`,"error" )
                }
            }
        } catch (e) {
            Sentry.captureException(`363 error in updating: ${e}`);
            console.log(e, "ERR-SU001 error in updating")
            showAlert(`ERR-SU001 Error in updating`,"error" )
        } finally {
            setLoader(false);

        }
    }

    useEffect(() => {
        if (initialMarkdown) {
            const fullHtml = converMarkToHtml(initialMarkdown);
            const innerHtml = extractInnerHtml(fullHtml);
            setContentHtml(innerHtml); // only the body goes into the editor
        }
    }, [initialMarkdown]);

    const handleSave = () => {
        const editorInstance = editorRef.current?.editor;
        const html = editorInstance?.getContents();
        const plainText = editorInstance?.getText()?.trim();
        if (!plainText) {
            showAlert("Please enter lesson content before saving.","warning")
            return;
        }
        onSave(html);
        onUpdate(html);
    };

    return (
        <>
            <Tooltip  title={from === "sentence_starter" ? "Edit Sentence Starter" : "Edit Lesson Plan"} >
                <Button
                    icon={<EditOutlined />}
                    shape="circle"
                    type="primary"
                    onClick={() => setVisible(true)}
                />
            </Tooltip>
            <SpinLoader dataloader={loader} />
            <Modal
                title={from === "sentence_starter" ? "Edit Sentence Starter" : "Edit Lesson Plan"}
                visible={visible}
                onOk={handleSave}
                onCancel={() => setVisible(false)}
                okText="Save"
                width={900}
                bodyStyle={{ padding: 0 }}
            >
                <SunEditor
                    getSunEditorInstance={(editor) =>
                        (editorRef.current = { editor })
                    }
                    setContents={contentHtml}
                    setOptions={{
                        height: 400,
                        showPathLabel: false,
                        buttonList: BUTTON_LIST,
                        plugins: [
                            blockquote,
                            align,
                            font,
                            fontColor,
                            fontSize,
                            formatBlock,
                            hiliteColor,
                            horizontalRule,
                            lineHeight,
                            list,
                            paragraphStyle,
                            table,
                            template,
                            textStyle,
                            image,
                            link,
                            SPANISH_ITEM_LOWER_PLUGIN,
                            SPANISH_ITEM_UPPER_PLUGIN,
                        ],
                    }}
                />
            </Modal>
        </>
    );
};

export default SuperLessonEditor;